import { useEffect, useState } from 'react';
import axios from 'axios';
import About from './About';

import API_BASE from "../api";

export default function Home({ lang, navigate }) {
  const [texts, setTexts] = useState(null);

  useEffect(() => {
    axios
      .get(API_BASE + '/api/texts')
      .then((res) => setTexts(res.data))
      .catch((err) => console.error(err));
  }, []);

  if (!texts) {
    return <div className="section">Ładowanie...</div>;
  }

  const tHome = texts.home?.[lang];
  const tAbout = texts.about?.[lang];

  return (
    <>
      <section className="hero">
        <div className="hero-text">
          <h1>{tHome?.title}</h1>
          <p>{tHome?.subtitle}</p>
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => navigate('/gallery')}>
              {tHome?.btnGallery}
            </button>
            <button className="btn-ghost" onClick={() => navigate('/contact')}>
              {tHome?.btnContact}
            </button>
          </div>
        </div>
        <div className="hero-image-wrapper">
          <img src="/images/hero.jpg" alt="Tekstylny obraz" />
        </div>
      </section>
      <About lang={lang} tAbout={tAbout} />
    </>
  );
}
